import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA, Injector, NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';
import { CommonCoreModule } from '@fedex/common-core';
import { DialogBoxComponent, DialogComponent, PclDsmModule } from 'fsc-pc-library';
import { NgbTooltipModule, NgbTooltipConfig } from '@ng-bootstrap/ng-bootstrap';
import { OktaAuthModule } from '@okta/okta-angular'; // comment for local
import { UserIdleModule } from 'angular-user-idle';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { ComponentLoaderFactory } from 'ngx-bootstrap/component-loader';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { PositioningService } from 'ngx-bootstrap/positioning';
import { ToastrModule, ToastContainerModule } from 'ngx-toastr';
import { environment } from 'src/environments/environment';
import { AppLoadService } from './app-load/app-load.service';
import { OktaConfigProvider } from './app-load/okta-config.provider';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FscCommonModule } from './components/fsccommon/fsccommon.module';
import { HomeComponent } from './components/home/home.component';
import { LoginComponent } from './components/login/login.component';
import { ManagecustomerComponent } from './components/managecustomer/managecustomer.component';
import { NotfoundComponent } from './components/notfound/notfound.component';
import { RegistrationComponent } from './components/registration/registration.component';
import { ReportsComponent } from './components/reports/reports.component';
import { FooterComponent } from './core/layout/footer/footer.component';
import { FscHFLayoutComponent } from './core/layout/fschflayout/fschflayout.component';
import { FsclayoutComponent } from './core/layout/fsclayout/fsclayout.component';
import { HeaderComponent } from './core/layout/header/header.component';
import { MenuListItemComponent } from './core/layout/menu-list-item/menu-list-item.component';
import { DragndropDirective } from './directives/dragndrop.directive';
import { HoverDirective } from './directives/hover.directive';
import { HttptokeninterceptorInterceptor } from './interceptor/httptokeninterceptor.interceptor';
import { AppMaterialModule } from './shared/appmaterial/appmaterial.module';
import { AgGridLicenseService } from './services/ag-grid-license.service';

import { PopAlertComponent } from './components/reverse/core/pop-alert/pop-alert.component';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { DatePipe } from '@angular/common';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { MissingTranslationHandler, MissingTranslationHandlerParams} from '@ngx-translate/core';

export function TranslationLoaderFactory(handler: HttpBackend) {
  const http = new HttpClient(handler);
  return new TranslateHttpLoader(http, 'assets/i18n/main/', '.json');
}
export function get_settings(appLoadService: AppLoadService) {
  return () => appLoadService.getSettings();
}

export function initializeAgGridLicense(agGridLicenseService: AgGridLicenseService) {
  return () => {
    // Service constructor already initializes the license
    return Promise.resolve();
  };
}

export class MyMissingTranslationHandler implements MissingTranslationHandler {
  handle(params: MissingTranslationHandlerParams) {
    
    if (params.interpolateParams) {
      return params.interpolateParams["Default"] || params.key;
    }
    return params.key;
  }
}

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    LoginComponent,
    RegistrationComponent,
    DragndropDirective,
    HeaderComponent,
    FooterComponent,
    FsclayoutComponent,
    NotfoundComponent,
    MenuListItemComponent,
    HoverDirective,
    FscHFLayoutComponent,
    ManagecustomerComponent,
    ReportsComponent,
    PopAlertComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    OktaAuthModule,
    FormsModule,
    NgbTooltipModule,
    ReactiveFormsModule,
    AppMaterialModule,
    FlexLayoutModule,
    BrowserAnimationsModule,
    PclDsmModule,
    FscCommonModule,
    ToastContainerModule,
    CommonCoreModule,
    NgMultiSelectDropDownModule.forRoot(),
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production === 'true' }),
    UserIdleModule.forRoot({ // FOR PRODUCTION - Coordinated with 55min token expiry
      idle: 3900,    // 65 minutes of inactivity (longer than token life)
      timeout: 600,  // 10 minute warning countdown
      ping: 600      // Check every 10 minutes for session extension
    }),
    // UserIdleModule.forRoot({ // FOR TESTING
    //   idle: 10,     // 10 seconds of inactivity
    //   timeout: 300,   // 5 minute warning countdown
    //   ping: 300     // Check every 5 minutes
    // }),
    TranslateModule.forRoot({
      defaultLanguage: 'en',
      missingTranslationHandler: {provide: MissingTranslationHandler, useClass: MyMissingTranslationHandler},
      loader: { provide: TranslateLoader, useFactory: TranslationLoaderFactory, deps: [HttpBackend] }
    }),
    ToastrModule.forRoot({
      timeOut: 5000,
      positionClass: 'toast-center-center',
      preventDuplicates: true,
    })
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: HttptokeninterceptorInterceptor, multi: true },
    AppLoadService, BsModalService, ToastContainerModule, BsModalRef, ComponentLoaderFactory, PositioningService, TranslateService,
    { provide: APP_INITIALIZER, useFactory: get_settings, deps: [AppLoadService, Injector], multi: true },
    { provide: APP_INITIALIZER, useFactory: initializeAgGridLicense, deps: [AgGridLicenseService], multi: true },
    { provide: MissingTranslationHandler, useClass: MyMissingTranslationHandler },
    OktaConfigProvider, NgbTooltipConfig, DatePipe,
    AgGridLicenseService
  ],
  bootstrap: [AppComponent],
  entryComponents:[
    DialogComponent,
    DialogBoxComponent
  ],
  schemas: [NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
